import React, { useEffect, useState } from "react";
import './CoverageCard.css';
import Card from 'react-bootstrap/Card';
import CheckboxComponent from "../CheckBox";
import Button from "../Button";
import PlusSvgIcon from '../../../assets/svg/plus.svg';
import MinusSvgIcon from '../../../assets/svg/minus.svg';
import InfoBar from "../InfoBars";

interface ListItem {
    id: any;
    name: string;
    code:string | number;
    
}
interface CoverageCardProps {
    listItems: ListItem[];
    onUnlink: (unLinkedFacilities: ListItem[]) => void;
    unlinkButtonName: string;
    linkButtonName:string;
    linkButtonStatus:any;
    onLink:() => void;
    required?:boolean,
    labelforCoverage:string
    inputType?: 'error' | 'success'|'' ;
    errorMessage?:string;
}

const CoverageCardComponent: React.FC<CoverageCardProps> = ({ listItems,onLink,linkButtonName,required, onUnlink, unlinkButtonName,labelforCoverage ,errorMessage,inputType,linkButtonStatus}) => {
    const [linkedFacilities, setLinkedFacilities] = useState(listItems);
    useEffect(() => {
        setLinkedFacilities(listItems);
    }, [listItems]);
    const [selectedFacilities, setSelectedFacilities] = useState<ListItem[]>([]);
    const handleCheckboxChange = (id: number, checked: boolean) => {
        const facility = listItems.find(item => item.id === id);
        if (!facility) return;
        if (checked) {
            setSelectedFacilities([...selectedFacilities, facility]);
            
        }
        else {
            setSelectedFacilities(selectedFacilities.filter((item) => item.id !== id));
            
        }
    };
    const handleUnlink = () => {
        const unLinkedFacilities = selectedFacilities;
        setLinkedFacilities(
            linkedFacilities.filter(
                (item) => !selectedFacilities.find((sel) => sel.id === item.id)
            ));
        setSelectedFacilities([]);
        onUnlink(unLinkedFacilities);
        
    }
    return (
        <div className="coverage-card-component">
            <label className={`label-name-css ${required && 'yes'} `}>{labelforCoverage}</label>
            <Card className="coverage-card-container" >
                <Card.Body className="coverage-card-body">
                    {linkedFacilities.map((item) => (
                        <div key={item.id}>
                            <CheckboxComponent
                                isChecked={!!selectedFacilities.find((sel) => sel.id === item.id)}
                                onCheckboxChange={(checked) => handleCheckboxChange(item.id, checked)}
                                checkBoxName={item.name} disabled={false} className="coverage-checkbox"
                            />
                        </div>
                    ))}
                </Card.Body>
                <Card.Footer className="coverage-card-footer">
                    <Button
                        buttonName={unlinkButtonName}
                        onClick={handleUnlink}
                        colorType={"primary"} id={""}
                        disabled={selectedFacilities.length === 0}
                        icon={<MinusSvgIcon />}
                        iconPosition={'left'}
                    />
                    <Button
                        buttonName={linkButtonName}
                        onClick={onLink}
                        colorType={"primary"} id={""}
                        disabled={linkButtonStatus === 0}
                        icon={<PlusSvgIcon />}
                        iconPosition={'left'}
                    />
                </Card.Footer>
            </Card>
            <div className="input_field_infoBars">
        {inputType === 'success' ? (
          <InfoBar
            variant="success"
            message={errorMessage?errorMessage:'Success'}
            className="input_field_class"
          />
        ) : (
          ''
        )}
        {inputType === 'error' ? (
          <InfoBar
            variant="danger"
            message={errorMessage?errorMessage:''}
            className="input_field_class"
          />
        ) : (
          ''
        )}
      </div>
        </div >
    )
}
export default CoverageCardComponent;